import { userConstants } from "../constants/login.constants";

 function asicDocumentTracking(state = {}, action) {
    switch (action.type) {
        case userConstants.ASICDOCUMENTTRACKING_REQUEST:
            return {
                loading: true
            };
        case userConstants.ASICDOCUMENTTRACKING_SUCCESS:
            return {
                items: action.asicDocumentTracking
            };
        case userConstants.ASICDOCUMENTTRACKING_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default asicDocumentTracking;